export default "__VITE_ASSET___70mKdC4__"